import routes from './routes';
import { SetRoutes } from 'components';

const StoreVsVillagePages = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default StoreVsVillagePages;
